import React from "react";
import {Box, Text, UnorderedList, ListItem} from "@chakra-ui/react";
import {ReferenceScanResult, RuleReference} from "./ruleReferences";

const renderReferenceList = (refs: RuleReference[]) => (
    <UnorderedList mt={2} mb={2}>
        {refs.map((ref) => (
            <ListItem key={`${ref.kind}:${ref.id}`}>
                <Text as={"span"} fontWeight={"semibold"}>
                    {ref.kind === "spot" ? "Spot: " : "Ambient: "}
                </Text>
                {ref.name}
            </ListItem>
        ))}
    </UnorderedList>
);

const renderScanFailedBody = (entityLabel: string) => (
    <Box>
        <Text>
            Couldn't verify whether this {entityLabel} is referenced by other rules.
        </Text>
        <Text mt={2} fontWeight={"semibold"}>
            Delete anyway?
        </Text>
    </Box>
);

const renderRefsBody = (entityLabel: string, refs: RuleReference[]) => (
    <Box>
        <Text>
            This {entityLabel} is referenced by trigger rules in the following:
        </Text>
        {renderReferenceList(refs)}
        <Text>
            Deleting will remove those rule references. This cannot be undone.
        </Text>
    </Box>
);

export const buildDeleteSpotConfirmBody = (scanResult: ReferenceScanResult): React.ReactNode => {
    if (scanResult === null) {
        return renderScanFailedBody("spot");
    }
    if (scanResult.length === 0) {
        return "Are you sure you want to delete this spot?";
    }
    return renderRefsBody("spot", scanResult);
};

export const buildDeleteZoneConfirmBody = (scanResult: ReferenceScanResult): React.ReactNode => {
    if (scanResult === null) {
        return renderScanFailedBody("ambient zone");
    }
    if (scanResult.length === 0) {
        return "Are you sure you want to delete this ambient zone?";
    }
    return renderRefsBody("ambient zone", scanResult);
};
